import { memo } from 'react';
import DashedLabel from '../../atoms/DashedLabel';
// @ts-expect-error module not typed
import { getTimestamp } from 'conversations-message-history/dates/operators/getters';
import { Text } from 'foundations-components/components/Text';
// @ts-expect-error module not typed
import formatMediumDate from 'I18n/utils/formatMediumDate';
import { jsx as _jsx } from "react/jsx-runtime";
const ShortDateLabel = /*#__PURE__*/memo(({
  message,
  ungatedForThreadMessagesUIImprovements
}) => {
  const timestamp = getTimestamp(message);
  const translatedDate = formatMediumDate(timestamp, 'userTz');
  return /*#__PURE__*/_jsx(DashedLabel, {
    "data-test-vr-hidden": true,
    ungatedForThreadMessagesUIImprovements: ungatedForThreadMessagesUIImprovements,
    children: /*#__PURE__*/_jsx(Text, {
      typography: "heading-25",
      color: "text-core-default",
      children: translatedDate
    })
  });
});
ShortDateLabel.displayName = 'ShortDateLabel';
export default ShortDateLabel;